import React, { useMemo, useEffect, useState } from 'react';
import { productList } from '../../Common/data';
import { useNavigate } from "react-router-dom";

import TableContainer from '../../Common/TableContainer';
import { Dropdown, Button, Card, Col, Container, Form, Modal, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { useReviewProductlistMutation } from '../../Redux/ReviewSlice';
import { getQueryString } from '../../lib/Validationtext';
import userDummy from '../../assets/images/userDummy.jpg';
import dummyImage from '../../assets/images/dummyImage.png';
import useDebounce from '../../hooks/useDebounce';

const ReviewTable = () => {
  const [ReviewlistFunc, { data: listData, error: listErr, isLoading: listLoading }] = useReviewProductlistMutation();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [limit, setlimit] = useState(100);
  const [search, setSearch] = useState('');
  const debounceSearch = useDebounce(search, 300)

  useEffect(() => {
    ReviewlistFunc(getQueryString({ page: page + 1, limit: limit, search: debounceSearch }))
  }, [page, limit, debounceSearch])
  console.log('listData', listData?.response, listData?.response)

  const handleValidDate = (date) => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  const handleValidTime = (time) => {
    const time1 = new Date(time);
    const getHour = time1.getUTCHours();
    const getMin = time1.getUTCMinutes();
    const getTime = `${getHour}:${getMin}`;
    var meridiem = "";
    if (getHour >= 12) {
      meridiem = "PM";
    } else {
      meridiem = "AM";
    }
    const updateTime = moment(getTime, 'hh:mm').format('hh:mm') + " " + meridiem;
    return updateTime;
  };

  const columns = useMemo(() => [

    {
      Header: "Product name",
      accessor: (cellProps) => (
        <>
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0 me-2">
              <div className="avatar-sm bg-light rounded p-1 d-flex justify-content-center">
                <img
                  src={cellProps?.ProductImageColourCombinations == [] ? dummyImage : cellProps?.ProductImageColourCombinations?.[0]?.image?.[0]?.preview
                  }
                  alt=""
                  className="img-fluid d-block avatar-xs mt-1"
                />
              </div>
            </div>
            <div className="flex-grow-1">
              <h5 className="fs-14 mb-1">
                <Link
                  to="/apps-ecommerce-product-details"
                  className="d-block text-reset"
                >
                  {" "}
                  {cellProps.productTitle}
                </Link>
              </h5>
              <p className="text-muted mb-0">
                Category :{" "}
                <span className="fw-medium">
                  {" "}
                  {cellProps?.ProductCategoryCombinations
                    ?.[0]?.Category?.name
                  }
                </span>
              </p>
            </div>
          </div>
        </>
      ),
    },
    {
      Header: "Users",
      Filter: false,
      accessor: (cellProps) => {
        console.log('cellProps', cellProps?.Reviews)
        return (
          <div className='multiple-users'>
            {cellProps?.Reviews?.length > 0 ?
              cellProps?.Reviews?.map((Itemimage, index) =>

                <div key={index}>
                  <img src={Itemimage?.User?.profileImage == null ? userDummy : Itemimage?.User?.profileImage?.url} alt="" />
                </div>
              ) :
              <div>
                <img src={userDummy} alt="" />
              </div>
            }
          </div>
        )
      }
    },
    {
      Header: "Ratings",
      Filter: false,
      accessor: (cellProps) => {
        return (
          <span>
            <span className="badge bg-light text-body fs-12 fw-medium"><i className="mdi mdi-star text-warning me-1"></i>{cellProps.averageRating}</span>
          </span>
        )
      }
    },
    {
      Header: "Price",
      // accessor: "sellingPrice",
      accessor: (cell) => {

        return (
          <div className='text-right'>{cell.sellingPrice}</div>
        )
      },
      Filter: false
    },
    {
      Header: "Pending Review",
      accessor: (cell) => {
        return (
          <div className='text-center'>{cell.numberOfPendingRating}</div>
        )
      },
      Filter: false
    },
    // {
    //   Header: "Orders",
    //   accessor: "orders",
    //   Filter: false,
    // },
    {
      Header: "Action",
      accessor: (cellProps) => {
        return (
          <ul className="hstack gap-2 list-unstyled mb-0">
            <li>
              <Button data-bs-toggle="offcanvas" className="badge bg-dark-subtle text-body view-item-btn" onClick={() => { navigate(`/reviews-ratingsdetails/${cellProps.id}`); }}>View</Button>
            </li>
          </ul>
          // <React.Fragment>
          //   <Dropdown className="text-center">
          //     <Dropdown.Toggle href="#" className="btn btn-ghost-primary btn-icon btn-sm arrow-none">
          //       <button type="button" data-bs-toggle="offcanvas" class="badge bg-dark-subtle text-body view-item-btn btn " onClick={() => { navigate(`/reviews-ratings/${cellProps.id}`); }}>View</button>
          //     </Dropdown.Toggle>
          //   </Dropdown>
          // </React.Fragment>
        );
      },
    },
  ],
    []
  );
  return (
    <React.Fragment>
      <Row id="usersList">
        <Col lg={12}>
          <Card>
            <Card.Body>
              <Row className="g-lg-2 g-4">
                <Col lg={3}>
                  <div className="search-box">
                    <input type="text" className="form-control search" placeholder="Search for users..." onChange={(e) => setSearch(e.target.value)} />
                    <i className="ri-search-line search-icon"></i>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <Card>
            <Card.Body className='p-0'>
              <TableContainer
                columns={(columns || [])}
                data={(listData?.response || [])}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                className="custom-header-css table align-middle table-nowrap"
                tableClass="table-centered align-middle table-nowrap mb-0"
                theadClass="text-muted table-light"
                SearchPlaceholder='Search Products...'
              />
              <div className="noresult" style={{ display: "none" }}>
                <div className="text-center">
                  <h5 className="mt-2">Sorry! No Result Found</h5>
                  <p className="text-muted mb-0">We've searched more than 150+ Orders We did not find any orders for you search.</p>
                </div>
              </div>

            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* <div>
        <TableContainer
          columns={columns}
          data={(listData?.response || [])}
          // isGlobalFilter={true}
          isAddUserList={false}
          customPageSize={10}
          // divClassName="table-responsive mb-1"
          tableClass="gridjs-table"
          theadClass="gridjs-th"
          isProductsFilter={true}
          SearchPlaceholder='Search Products...'
        />
      </div> */}
    </React.Fragment>
  );
};

export default ReviewTable;
